<template>
    <div class="table-responsive m-t-20">
        <table class="display nowrap table table-hover table-striped table-bordered dataTable">
            <thead>
            <tr>
                <th role="row" v-for="key in columns" @click="sortBy(key)" :class="thClass(key)">
                    <slot name="th" :item="key">
                        {{ key }}
                    </slot>
                    <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'"></span>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(entry, index) in entries">
                <td v-for="key in columns" :class="tdClass(key)">
                    <slot :name="td(key)" :item="entry" :index="index">
                        {{ entry[key] }}
                    </slot>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
  export default {
    name: 'TournTable',
    props: {
      columns: Array,
      data: Array,
      settings: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      let sortOrders = {};
      this.columns.forEach(key => {
        sortOrders[key] = 1;
      });
      return {
        sortKey: '',
        sortOrders: sortOrders,
      };
    },
    computed: {
      entries() {
        let sortKey = this.sortKey;
        let order = this.sortOrders[sortKey] || 1;
        let entries = this.data;
        if (sortKey) {
          entries = entries.slice().sort(function (a, b) {
            a = a[sortKey];
            b = b[sortKey];
            return (a === b ? 0 : a > b ? 1 : -1) * order;
          });
        }
        return entries;
      },
    },
    methods: {
      sortBy(key) {
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
      },
      thClass(key) {
        let classes = this.getSettingsArray(key, ['class', 'thClass']);

        if (this.sortKey === key) {
          classes.push('active');
        }

        return classes;
      },
      tdClass(key) {
        return this.getSettingsArray(key, ['class', 'tdClass']);
      },
      getSettingsArray(key, types = []) {
        let settings = this.settings[key] || {};
        let all = [];
        for (const type of types) {
          let array = settings[type] || null;
          if (array === null || typeof array === 'undefined') {
            continue;
          }
          if (!Array.isArray(array)) {
            array = [array];
          }
          all = all.concat(array);
        }
        return all;
      },
      th(key) {
        return 'th-' + key;
      },
      td(key) {
        return 'td-' + key;
      },
    },
  };
</script>

<style lang="scss" scoped>
    th {
        cursor: pointer;
        opacity: 0.66;

        &.active {
            opacity: 1;
        }
    }

    .arrow {
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        margin-left: 5px;

        &.asc {
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-bottom: 4px solid #fff;
        }

        &.dsc {
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #fff;
        }
    }
</style>
